import React, { useEffect, useState } from 'react'
import { getState } from '../../redux/store'
import { Avatar, Button, message, Switch, Tooltip, Typography } from 'antd'
import { LockOutlined, UserOutlined } from '@ant-design/icons'
import styles from './styles/cabinet.module.css'
import { ChangePasswordModal } from './Modals/ChangePasswordModal'
import { MfaDisableModal } from './Modals/MFADisableModal'
import { MfaEnableModal, ModalType } from './Modals/MFAEnableModal'
import { FileSelect, FileSelectType } from './FileSelect'
import { SkinModal } from './Modals/SkinModal'
import { ebalas } from '../../api/utils'

// eslint-disable-next-line sonarjs/cognitive-complexity
export const Cabinet = (): React.ReactElement => {
	const user = getState(s => s.user)
	const [
		changePasswordModalVisible,
		setChangePasswordModalVisible
	] = useState(false)

	const [
		disableMFAModalVisibility,
		setDisableMFAModalVisibility
	] = useState(false)

	const [
		enableMFAModalVisibility,
		setEnableMFAModalVisibility
	] = useState(false)

	const [
		skinModalVisibility,
		setSkinModalVisibility
	] = useState(false)

	const [switchState, setSwitchState] = useState(user.isMFAEnabled)

	const [skinUpdated, updateSkin] = useState(true)
	const [skinSlim, setSlimSkinState] = useState(user.isSlim)
	const [skinUrl, setSkinUrl] = useState(`${ebalas}/${user.uuid}.png`)

	function closeModal(type: ModalType, result?: boolean) {
		if (type === ModalType.DISABLE) {
			if (result) {
				void message.info({
					message: '2FA авторизация успешно выключена!'
				})

				setSwitchState(false)
			} else {
				setSwitchState(true)
			}

			setDisableMFAModalVisibility(false)
		}

		if (type === ModalType.ENABLE) {
			if (result) {
				void message.success({
					message: '2FA авторизация успешно включена!'
				})

				setSwitchState(true)
			} else {
				setSwitchState(false)
			}
			setEnableMFAModalVisibility(false)
		}
	}

	return (
		<div className={styles['main-block']}>
			{skinUpdated ? (
				<SkinModal
					visible={skinModalVisibility}
					onClose={() => setSkinModalVisibility(false)}
					isSlim={skinSlim}
				/>
			) : <></>}

			<Tooltip title="Нажмите, чтобы открыть окно просмотра скина" color="#108ee9">
				<div onClick={() => setSkinModalVisibility(true)}>
					<Avatar
						size={128}
						src={skinUrl}
						onError={() => {
							setSkinUrl(`${ebalas}/null.png`)
							return false
						}}
						icon={<UserOutlined/>}
						className={styles['avatar']}
					/>
				</div>
			</Tooltip>

			<div className={styles['user-name-block']}>
				<Typography.Title level={2}>{user.nick}</Typography.Title>
				<Typography>{user.privilege}</Typography>
			</div>

			<div className={styles['columns-block']}>
				<div className={styles['column']}>
					<div className={styles['column-header']}>
						<Typography.Title level={4}>
							<LockOutlined style={{ marginRight: '8px' }} />
							Безопасность
						</Typography.Title>
					</div>

					<div className={styles['column-body']}>
						<div className={styles['column-body-cell']}>
							<Typography.Title level={5}>
								<span className={styles['cell-icon']}></span>
								Пароль
							</Typography.Title>
							<Button
								onClick={() => setChangePasswordModalVisible(true)}
							>
								Изменить
							</Button>

							<ChangePasswordModal
								open={changePasswordModalVisible}
								close={() => setChangePasswordModalVisible(false)}
							/>
						</div>
						<div className={styles['column-body-cell']}>
							<Typography.Title level={5}>
								<span className={styles['cell-icon']}></span>
								2FA
							</Typography.Title>
							<Switch
								checked={switchState}
								onChange={value => {
									if (value) {
										setEnableMFAModalVisibility(true)
									} else {
										setDisableMFAModalVisibility(true)
									}
								}}
							/>

							<MfaDisableModal
								close={closeModal}
								visible={disableMFAModalVisibility}
							/>

							<MfaEnableModal
								close={closeModal}
								visible={enableMFAModalVisibility}
							/>
						</div>
					</div>

					<div className={styles['column-header']}>
						<Typography.Title level={4}>
							<span className={styles['header-icon']}></span>
							Кастомизация
						</Typography.Title>
					</div>

					<div className={styles['column-body']}>
						<div className={styles['column-body-cell']}>
							<Typography.Title level={5}>
								<span className={styles['cell-icon']}></span>
								Скин
							</Typography.Title>
							<FileSelect
								type={FileSelectType.Skin}
								onChanged={(deleted, isSlim) => {
									if (deleted) {
										setSkinUrl(`${ebalas}/null.png`)
									} else {
										setSkinUrl(`${ebalas}/${user.uuid}.png`)
									}
									if (isSlim !== null) {
										setSlimSkinState(isSlim)
									}
									updateSkin(false)
									updateSkin(true)
								}}
							/>
						</div>
						<div className={styles['column-body-cell']}>
							<Typography.Title level={5}>
								<span className={styles['cell-icon']}></span>
								Плащ
							</Typography.Title>
							<FileSelect
								type={FileSelectType.Cloak}
								onChanged={() => {
									updateSkin(false)
									updateSkin(true)
								}}
							/>
						</div>
					</div>
				</div>
			</div>
		</div>
	)
}

export const routePathCabinet = '/cabinet'
